/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/** How many overlays hold the page still. */
let holders = 0;
/** The page's own `overflow`, from before the first holder took the lock. */
let pageOverflow = '';

/**
 * Stops the page scrolling behind an overlay, and returns the release.
 *
 * Overlays stack, and the one underneath can close first, so the lock is counted: the first
 * holder saves the page's own `overflow`, and only the last release puts it back. A release
 * counts once, however often it is called.
 */
export function lockBodyScroll(): () => void {
  if (holders === 0) {
    pageOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  holders += 1;
  let held = true;
  return () => {
    if (!held) return;
    held = false;
    holders -= 1;
    if (holders === 0) document.body.style.overflow = pageOverflow;
  };
}
